import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import checkIsMobile from 'shared/utils/checkMobileDevice';
import { branch, compose, renderComponent } from 'recompose';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { hideAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { getCallerName } from 'modules/appointmentInfo/selectors/currentAppointmentDetails';
import VideoContentPending from 'modules/appointmentInfo/components/_placeholders/VideoContentPending';

import VideoSidebar from './VideoSidebar';


const mapStateToProps = (state, ownProps) => {
  const { requestStatus } = state.appointmentInfo.currentAppointment;

  return {
    isMobile: checkIsMobile(),
    conferenceStarted: conferenceInProgress(state),
    callerName: getCallerName(state, ownProps.intl),
    isConferenceInProgress: conferenceInProgress(state),
    status: state.conference.currentConversation?.status,
    isAppointmentFetching: requestStatus !== requestsStatuses.success,
    consultationStartedTime: state.conference.consultationStats.consultationStartedTime,
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, { hideAppointmentInfo }),

  branch(
    ({ isAppointmentFetching }) => isAppointmentFetching,
    renderComponent(VideoContentPending),
  ),
)(VideoSidebar);
